import { Plus, SaveIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ServiceData } from "../Services/Service";

interface InterfaceManager {
  id: number;
  nom: string;
}

interface BordereauModalProps {
  form: any;
  error: string | null;
  isEditMode: boolean;
  isModifier?: boolean;
  isAdminOrMagasinLoin: boolean;
  handleSubmit: (e: React.FormEvent) => void;
  handleInputChange: (field: string, value: any) => void;
  closeModal: () => void;
  handleNumBlChange?:(index:number,value:string)=>void;
  handleAddNumBl?:()=>void;
  handleRemoveNumBl?:(index:number)=>void;
}

const ModalBordereauFormAdmin: React.FC<BordereauModalProps> = ({
  form,
  error,
  isEditMode,
  isModifier,
  isAdminOrMagasinLoin,
  handleSubmit,
  handleInputChange,
  closeModal,
  handleNumBlChange,handleAddNumBl,handleRemoveNumBl
}) => {
  const [listData, setListData] = useState<{
    livreurs: InterfaceManager[];
    clients: InterfaceManager[];
    cooperatives: InterfaceManager[];
  }>({
    livreurs: [],
    clients: [],
    cooperatives: [],
  });

  const [showAdd, setShowAdd] = useState({
    livreur: false,
    destinataire: false,
    cooperative: false,
  });

  const [newEntries, setNewEntries] = useState({
    livreur: "",
    destinataire: "",
    cooperative: "",
  });

  const [erreurdata, setErreurData] = useState<string | null>(null);
  const [loading,setLoading]=useState<boolean>(true);

  const endpoints = {
    livreur: {
      list: "/api/admin/listlivreur",
      create: "/api/admin/createlivreur",
    },
    destinataire: {
      list: "/api/admin/listclient",
      create: "/api/admin/createclient",
    },
    cooperative: {
      list: "/api/admin/listcooperative",
      create: "/api/admin/createcooperative",
    },
  };

  const listKeyMap: Record<keyof typeof newEntries, keyof typeof listData> = {
    destinataire: "clients",
    livreur: "livreurs",
    cooperative: "cooperatives",
  };

  const fetchData = async () => {
    try {
      const [livreurs, clients, cooperatives] = await Promise.all([
        ServiceData(endpoints.livreur.list, "GET"),
        ServiceData(endpoints.destinataire.list, "GET"),
        ServiceData(endpoints.cooperative.list, "GET"),
      ]);
      setListData({
        livreurs: Array.isArray(livreurs) ? livreurs : [],
        clients: Array.isArray(clients) ? clients : [],
        cooperatives: Array.isArray(cooperatives) ? cooperatives : [],
      });
      setLoading(false);
    } catch (err: any) {
      setLoading(true);
      setErreurData("Erreur chargement données : " + err.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAddEntity = async (key: keyof typeof newEntries) => {
    const value = newEntries[key].trim();
    if (!value) return setErreurData(`Veuillez saisir un nom de ${key}.`);

    const listKey = listKeyMap[key];
    const list = listData[listKey];

    const exists = list.some((e) => e.nom.toLowerCase() === value.toLowerCase());
    if (exists) return setErreurData(`Ce ${key} existe déjà.`);

    try {
      const newItem = await ServiceData(endpoints[key].create, "POST", { nom: value });
      setListData((prev) => ({
        ...prev,
        [listKey]: [...prev[listKey], newItem],
      }));
      setNewEntries((prev) => ({ ...prev, [key]: "" }));
      setShowAdd((prev) => ({ ...prev, [key]: false }));
    } catch (err: any) {
      setErreurData(`Erreur ajout ${key} : ` + err.message);
    }
  };

  const renderSelectWithAdd = (
    label: string,
    field: keyof typeof newEntries,
    list: InterfaceManager[],
    formValue: string
  ) => (
    <div>
      <label>{label}</label>
      <select
        className="form-control mb-2"
        value={formValue ?? ""}
        onChange={(e) => handleInputChange(field, e.target.value)}
      >
        <option value="" disabled={loading} >{loading ? 'Attendez...' : `Sélectionner ${label.toLowerCase()}`}</option>
        {list.map((l) => (
          <option key={l.id ?? l.nom} value={l.nom}>
            {l.nom.toLocaleUpperCase()}
          </option>
        ))}
      </select>
      <button
        type="button"
        className="btn btn-outline-success mb-2"
        onClick={() => setShowAdd((prev) => ({ ...prev, [field]: true }))}
      >
        <Plus />
      </button>
      {showAdd[field] && (
        <div>
          <input
            className="form-control mb-2"
            placeholder={`Nouveau ${label.toLowerCase()}`}
            value={newEntries[field]}
            onChange={(e) => setNewEntries((prev) => ({ ...prev, [field]: e.target.value }))}
          />
          <button
            className="btn btn-sm btn-primary"
            type="button"
            onClick={() => handleAddEntity(field)}
          >
            <SaveIcon /> Enregistrer
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div className="modal show fade d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header" style={{backgroundColor: 'green',color: 'white',alignItems: 'center'}}>
              <h5 className="modal-title">
                {(isEditMode || isModifier) ? `Modifier ${form.destinataire}` : 'Créer un bordereau'}
              </h5>
              <button type="button" className="btn-close"  onClick={closeModal}></button>
            </div>
            <div className="modal-body">
              {error && <p className="text-danger">{error}</p>}
              {erreurdata && <p className="text-danger">{erreurdata}</p>}

              {renderSelectWithAdd("Client", "destinataire", listData.clients, form.destinataire)}

              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Colis</span>
                    <input
                      type="number"
                      className="form-control"
                      id="colisInput"
                      placeholder="Entrez le nombre"
                      min="0"
                      value={form.nombres}
                      onChange={e => handleInputChange("nombres", e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Pack</span>
                    <input
                      type="number"
                      className="form-control"
                      id="packInput"
                      placeholder="Entrez le nombre"
                      min="0"
                      value={form.nombrepack}
                      onChange={e => handleInputChange("nombrepack", e.target.value)}
                    />
                  </div>
                </div>
                <div>
                  <label>Date de livraison</label>
                  <input className="form-control mb-2" type="datetime-local" value={form.datelivraison} onChange={e =>
                    handleInputChange("datelivraison", e.target.value)} />
                </div>
              </div>

             <div className="mb-2">
              <div className="btn-group" role="group" aria-label="Bon de livraison">
                <input type="radio" className="btn-check" name="bon" id="avec-bl" autoComplete="off" checked={form.bon === 'Avec BL'} onChange={() => handleInputChange("bon", "Avec BL")}/>
                <label className="btn btn-outline-primary" htmlFor="avec-bl">Avec BL</label>
                <input type="radio" className="btn-check" name="bon" id="sans-bl" autoComplete="off" checked={form.bon === 'Sans BL'} onChange={() => handleInputChange("bon", "Sans BL")}/>
                <label className="btn btn-outline-danger" htmlFor="sans-bl">Sans BL</label>
              </div>
            </div>
            <div className="mb-2">
              
              <label className="form-label">Numéro BL</label>
              {
                Array.isArray(form.NumBl) &&
                form.NumBl.map((value:string,index:number)=>(
                  <div key={index} className="d-flex gap-2 mb-2">
                    <input type="text" className="form-control" value={value} onChange={(e)=>handleNumBlChange?.(index,e.target.value)} placeholder={`Numéro BL ${index + 1}`}/>
                    <button type="button" className="btn btn-danger" onClick={()=>handleRemoveNumBl?.(index)}>❌</button>
                  </div>
                ))
              }
              <button type="button" className="btn btn-outline-primary mb-3" onClick={handleAddNumBl}>➕ Ajouter un Numéro BL</button>
              
            </div>
            {
              isEditMode && isAdminOrMagasinLoin && (
                <>
                <p className="text-primary">Autres informations</p>
                {renderSelectWithAdd("Livreur", "livreur", listData.livreurs, form.livreur)}

                <div>
                  <label>Chauffeur</label>
                  <input className="form-control mb-2" value={form.chaffeur ?? ""} onChange={e =>
                    handleInputChange("chaffeur", e.target.value)} />
                </div>
                <div>
                  <label>Véhicule</label>
                  <input className="form-control mb-2" value={form.vehicule ?? ""} onChange={e =>
                    handleInputChange("vehicule", e.target.value)} />
                </div>
                <div>
                  <label>Téléphone</label>
                  <input className="form-control mb-2" value={form.telephone ?? ""} onChange={e =>
                    handleInputChange("telephone", e.target.value)} />
                </div>
                {renderSelectWithAdd("Coopérative", "cooperative", listData.cooperatives, form.cooperative)}
                </>
              )
            }
              
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline-dark" type="submit">
                <SaveIcon /> Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalBordereauFormAdmin;
